var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { DisablePointerEventsOnScroll } from "@irati/ui/src/Feed";
import { injectIntl } from "@irati/utils/lang";
import Loader from "@irati/utils/services/apollo/Loading/Loader";
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom";
import ListQuery from "@irati/companyvalues/apollo/query/CompanyValuesList";
import authentication from "@irati/auth";
import { CompanyValueRow, Empty, Header, LoadMore } from "./index";
import { CompanyValueArchive } from "../index";
var CompanyValuesList = /** @class */ (function (_super) {
    __extends(CompanyValuesList, _super);
    function CompanyValuesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            archiveCompanyValue: undefined,
            hasRefetchingError: false
        };
        _this.onLoadMore = null;
        _this.handleScroll = function () {
            var atBottom = scrollAtBottom();
            var hasRefetchingError = _this.state.hasRefetchingError;
            if (atBottom && !hasRefetchingError) {
                _this.fetchMore();
            }
        };
        _this.handleNetworkStatusChange = function () {
            var hasRefetchingError = _this.state.hasRefetchingError;
            if (navigator.onLine && hasRefetchingError) {
                _this.fetchMore();
            }
        };
        _this.fetchMore = function () {
            if (_this.onLoadMore) {
                _this.setState({
                    hasRefetchingError: false
                });
                _this.onLoadMore().catch(function () {
                    _this.setState({
                        hasRefetchingError: true
                    });
                });
            }
        };
        _this.closeArchiveModal = function () { return _this.setState({ archiveCompanyValue: undefined }); };
        _this.archiveCompanyValue = function (companyValue) {
            _this.setState({ archiveCompanyValue: companyValue });
        };
        return _this;
    }
    CompanyValuesList.prototype.componentDidMount = function () {
        window.addEventListener("online", this.handleNetworkStatusChange);
        window.addEventListener("scroll", this.handleScroll);
    };
    CompanyValuesList.prototype.componentWillUnmount = function () {
        window.removeEventListener("online", this.handleNetworkStatusChange);
        window.removeEventListener("scroll", this.handleScroll);
    };
    CompanyValuesList.prototype.hasReceivedData = function (data) {
        return data && "companyValues" in data && "results" in data.companyValues && data.companyValues.results.length > 0;
    };
    CompanyValuesList.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClick = _a.onClick, setupView = _a.setupView;
        var _b = this.state, archiveCompanyValue = _b.archiveCompanyValue, hasRefetchingError = _b.hasRefetchingError;
        var tenantId = authentication.userTenant().uuid;
        var params = {
            limit: 10,
            page: 0,
            tenantId: tenantId
        };
        var calculatedFetchPolicy = setupView ? "network-only" : "cache-first";
        return (React.createElement(React.Fragment, null,
            React.createElement(DisablePointerEventsOnScroll, null,
                React.createElement(ListQuery, { fetchPolicy: calculatedFetchPolicy, variables: params }, function (_a) {
                    var data = _a.data, onLoadMore = _a.onLoadMore, refetch = _a.refetch, isLoading = _a.loading, error = _a.error, networkStatus = _a.networkStatus;
                    var hasData = _this.hasReceivedData(data);
                    var hasError = error || hasRefetchingError;
                    var isFetchingMore = networkStatus === 3;
                    _this.onLoadMore = !isLoading ? function () { return onLoadMore(); } : null;
                    return isLoading && !isFetchingMore ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null,
                        React.createElement(Header, { onClick: function () { return onClick(); }, count: data.companyValues.total }),
                        data &&
                            hasData &&
                            data.companyValues.results.map(function (companyValue, index) { return (React.createElement(CompanyValueRow, { companyValue: companyValue, key: companyValue.uuid, id: "companyValue" + index, editCompanyValue: function () { return onClick(companyValue); }, archiveCompanyValue: function () { return _this.archiveCompanyValue(companyValue); } })); }),
                        isLoading && React.createElement(Loader, null),
                        !isLoading && hasError && React.createElement(LoadMore, { onClick: error ? function () { return refetch(); } : _this.fetchMore }),
                        !isLoading && !hasError && !hasData && React.createElement(Empty, null)));
                })),
            archiveCompanyValue && React.createElement(CompanyValueArchive, { closeArchiveModal: this.closeArchiveModal, companyValue: archiveCompanyValue })));
    };
    return CompanyValuesList;
}(Component));
export default injectIntl(CompanyValuesList);
